import React from "react";
import ReactDOM from "react-dom";
import configureStore from './store/configureStore';  //wire up redux store to the entry point for application
import {Provider} from 'react-redux';  //Companion lib, higher order component..for wrapping.
import { HashRouter, Route, Switch } from "react-router-dom";
import {setUserLoggedOut} from './actions/loginActions';

import indexRoutes from "./routes/index.jsx";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/light-bootstrap-dashboard.css?v=1.1.0";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";

const store = configureStore();


//10/31/2019  I added support for the Stripe Provider, wrapped my existing Redux store below with the Stripe Provider
//Object.

ReactDOM.render(
    <Provider store={store}>
      <HashRouter>
        <Switch>
          {indexRoutes.map((prop, key) => {
            return <Route path={prop.path} component={prop.component} key={key} />;
          })}
        </Switch>
      </HashRouter>
    </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js